<template lang="html">
    <div class="box-email">
      <div class="text-xs-center info-hotsite">
        Digite abaixo o seu e-mail de acesso ao portal da administradora do seu condomínio.
      </div>
      <v-form v-on:submit.prevent="checkEmail">
        <v-text-field
        label="Seu e-mail"
        append-icon="email"
        :value="email"
        @input="updateEmail"
        ></v-text-field>
        <v-btn
        large
        :loading="loadingEmail"
        @click.native="loader = 'loading'"
        :disabled="loadingEmail"
        v-on:click='checkEmail'
        class="btn-hotsite"
        block
        >
        Acessar
        <span slot="loader" class="custom-loader">
          <v-icon light>cached</v-icon>
        </span>
      </v-btn>
      <cant-access :token="token">
        <v-btn
        large
        class="btn-hotsite-gray"
        block
        >
        Não estou conseguindo acessar
        <span slot="loader" class="custom-loader">
          <v-icon light>cached</v-icon>
        </span>
      </v-btn>
      </cant-access>
    </v-form>
    </div>
</template>

<script>
import CantAccess from './CantAccess'

export default {
  name: 'check-in',
  props: ['token'],
  components: {
    CantAccess
  },
  computed: {
    email () {
      return this.$store.getters.email
    },
    loadingEmail () {
      return this.$store.getters.loadingEmail
    }
  },
  methods: {
    updateEmail (value) {
      this.$store.commit('updateEmail', value)
    },
    checkEmail () {
      this.$store.dispatch('checkEmail', this.token)
    }
  },
  mounted () {
    this.$store.dispatch('getCupom', this.token)
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// Checkin.vue?87ff4238